import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useForm, useField } from 'react-final-form-hooks';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import { usersInviteInit, usersInvite } from '../../actions/User/UserActions';

import Modal from '../Modal';

import {
  Form,
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Button,
  Box,
  Row,
  InputboxHolder,
  Inputbox,
  Input,
  Textbox,
  Text,
  Item,
  ItemInner,
  SubtitleHolder,
  Subtitle,
  Link,
  Icon,
} from './ProfileManageUsersInviteUsers.style';

const ProfileManageUsersInviteUsersInner = ({ handleClose = () => {} }) => {
  const intl = useIntl();
  const theme = useTheme();

  const usersInviteStore = useSelector((state) => state.usersInviteStore);
  const { isLoading, isSuccess, isError, error } = usersInviteStore;
  const dispatch = useDispatch();

  const [usersCount, setUsersCount] = useState(1);
  const [users, setUsers] = useState({});
  const [usersInputTouches, setUsersInputTouches] = useState({});

  const validate = (values) => {
    const errors = {};

    if (!values.users || Object.keys(values.users).length === 0)
      errors.users = intl.formatMessage({
        id: 'FORM.VALIDATION.THIS_FIELD_IS_REQUIRED',
      });
    if (values.users) {
      const usersErrors = {};
      Object.entries(values.users).forEach(([index, user]) => {
        if (
          user.name &&
          !/^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/.test(
            user.name
          )
        ) {
          if (!usersErrors[index]) usersErrors[index] = {};
          usersErrors[index].name = intl.formatMessage({
            id: 'FORM.VALIDATION.INVALID_FORMAT',
          });
        }

        if (
          user.email &&
          !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            user.email
          )
        ) {
          if (!usersErrors[index]) usersErrors[index] = {};
          usersErrors[index].email = intl.formatMessage({
            id: 'FORM.VALIDATION.INVALID_FORMAT',
          });
        }
      });
      if (Object.keys(usersErrors).length > 0) {
        errors.users = intl.formatMessage({
          id: 'FORM.VALIDATION.INVALID_FORMAT',
        });
      } else {
      }
    }
    return errors;
  };

  const onSubmit = (values) => {
    try {
      dispatch(
        usersInvite({
          users:
            (values.users &&
              Object.values(values.users)
                .filter((user) => user.name && user.email)
                .map((user) => ({
                  full_name: user.name,
                  email: user.email,
                }))) ||
            [],
        })
      );
    } catch {}
  };

  const { form, handleSubmit, pristine, submitting, invalid } = useForm({
    onSubmit,
    validate,
  });

  useField('users', form);

  useEffect(() => {
    dispatch(usersInviteInit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    form.change('users', users);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  const renderUserField = (index) => {
    const handleAddUserField = () => {
      setUsersCount(usersCount + 1);
    };

    const handleUserName = (value) => {
      setUsers(
        Object.assign({}, users, {
          [index]: {
            ...users[index],
            name: value,
          },
        })
      );
    };

    const handleUserEmail = (value) => {
      setUsers(
        Object.assign({}, users, {
          [index]: {
            ...users[index],
            email: value,
          },
        })
      );
    };

    return (
      <ItemInner>
        <SubtitleHolder>
          {index === 0 ? (
            <Subtitle theme={theme.profileManageUsersInviteUsers.subtitle}>
              {intl.formatMessage({
                id:
                  'PROFILE_MANAGE_USERS_INVITE_USERS.DEFINE_EMAILS_AND_FULL_NAMES',
              })}
            </Subtitle>
          ) : (
            ''
          )}
          {index === 0 ? (
            <Link
              theme={theme.link}
              onClick={() => {
                handleAddUserField();
              }}
            >
              <Icon className='material-icons'>add</Icon>
              {intl.formatMessage({
                id: 'PROFILE_MANAGE_USERS_INVITE_USERS.ADD_ANOTHER_USER',
              })}
            </Link>
          ) : (
            ''
          )}
        </SubtitleHolder>
        <InputboxHolder>
          <Inputbox>
            <Input
              theme={theme.input.default}
              name={users && users[index] && users[index].name}
              defaultValue={users && users[index] && users[index].name}
              placeholder={intl.formatMessage({
                id: 'PROFILE_MANAGE_USERS_INVITE_USERS.INPUT.FULL_NAME',
              })}
              onChange={(e) => {
                handleUserName(e.currentTarget.value);
              }}
              onBlur={() => {
                const newUsersInputTouches = { ...usersInputTouches };
                if (!newUsersInputTouches[index])
                  newUsersInputTouches[index] = {};
                newUsersInputTouches[index].name = true;
                setUsersInputTouches(newUsersInputTouches);
              }}
              invalid={
                usersInputTouches &&
                usersInputTouches[index] &&
                usersInputTouches[index].name &&
                users &&
                users[index] &&
                users[index].name
                  ? !/^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/.test(
                      users[index].name
                    )
                  : false
              }
            />
          </Inputbox>
          <Inputbox>
            <Input
              theme={theme.input.default}
              type={'email'}
              name={users && users[index] && users[index].email}
              defaultValue={users && users[index] && users[index].email}
              placeholder={intl.formatMessage({
                id: 'PROFILE_MANAGE_USERS_INVITE_USERS.INPUT.EMAIL',
              })}
              onChange={(e) => {
                handleUserEmail(e.currentTarget.value);
              }}
              onBlur={() => {
                const newUsersInputTouches = { ...usersInputTouches };
                if (!newUsersInputTouches[index])
                  newUsersInputTouches[index] = {};
                newUsersInputTouches[index].email = true;
                setUsersInputTouches(newUsersInputTouches);
              }}
              invalid={
                usersInputTouches &&
                usersInputTouches[index] &&
                usersInputTouches[index].email &&
                users &&
                users[index] &&
                users[index].email
                  ? !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                      users[index].email
                    )
                  : false
              }
            />
          </Inputbox>
        </InputboxHolder>
      </ItemInner>
    );
  };

  const renderSuccessPanel = () => {
    return (
      <Wrapper theme={theme.profileManageUsersInviteUsers.wrapper}>
        <Header theme={theme.profileManageUsersInviteUsers.header}>
          <Title theme={theme.profileManageUsersInviteUsers.title}>
            {intl.formatMessage({
              id: 'PROFILE_MANAGE_USERS_INVITE_USERS.SUCCESS',
            })}
          </Title>
        </Header>
        <Content>
          <Box>
            <Textbox center>
              <Text theme={theme.profileManageUsersInviteUsers.text.default}>
                {intl.formatMessage({
                  id: `PROFILE_MANAGE_USERS_INVITE_USERS.TEXT.THE_USERS_HAVE_BEEN_SUCCESSFULLY_INVITED`,
                })}
              </Text>
            </Textbox>
          </Box>
        </Content>
        <Footer>
          <Button
            type='button'
            theme={theme.button.default}
            onClick={() => {
              handleClose();
            }}
          >
            {intl.formatMessage({ id: 'PROFILE_MANAGE_USERS_INVITE_USERS.OK' })}
          </Button>
        </Footer>
      </Wrapper>
    );
  };

  return (
    <>
      {isSuccess ? (
        renderSuccessPanel()
      ) : (
        <Form onSubmit={handleSubmit}>
          <Wrapper theme={theme.profileManageUsersInviteUsers.wrapper}>
            <Header theme={theme.profileManageUsersInviteUsers.header}>
              <Title theme={theme.profileManageUsersInviteUsers.title}>
                {intl.formatMessage({
                  id: 'PROFILE_MANAGE_USERS_INVITE_USERS.INVITE_USERS',
                })}
              </Title>
            </Header>
            <Content>
              <Box>
                <Row theme={theme.dataSourceAdd.row}>
                  <Item>
                    {[...Array(usersCount)].map((_, key) => (
                      <Fragment key={key}>{renderUserField(key)}</Fragment>
                    ))}
                  </Item>
                </Row>
              </Box>
            </Content>
            {isError ? (
              <Textbox>
                <Text theme={theme.dataSourceDelete.text.error}>
                  {intl.formatMessage({
                    id: `PROFILE_MANAGE_USERS_INVITE_USERS.TEXT.ERROR.${error}`,
                    defaultMessage: error,
                  })}
                  .
                </Text>
              </Textbox>
            ) : (
              ''
            )}
            <Footer>
              <Button
                type='button'
                theme={theme.button.alt}
                disabled={isLoading}
                onClick={() => {
                  handleClose();
                }}
              >
                {intl.formatMessage({
                  id: 'PROFILE_MANAGE_USERS_INVITE_USERS.CANCEL',
                })}
              </Button>
              <Button
                theme={theme.button.default}
                disabled={submitting || pristine || invalid || isLoading}
              >
                {isLoading
                  ? intl.formatMessage({
                      id: 'PROFILE_MANAGE_USERS_INVITE_USERS.PLEASE_WAIT',
                    })
                  : intl.formatMessage({
                      id: `PROFILE_MANAGE_USERS_INVITE_USERS.INVITE`,
                    })}
              </Button>
            </Footer>
          </Wrapper>
        </Form>
      )}
    </>
  );
};

const ProfileManageUsersInviteUsers = ({ handleClose = () => {} }) => {
  return (
    <Modal handleClose={handleClose}>
      <ProfileManageUsersInviteUsersInner handleClose={handleClose} />
    </Modal>
  );
};

ProfileManageUsersInviteUsers.propTypes = {
  handleClose: PropTypes.func,
};

ProfileManageUsersInviteUsers.propTypes = {
  handleClose: PropTypes.func,
};

export default ProfileManageUsersInviteUsers;
